/* eslint-disable import/prefer-default-export */

export const APP_ENTRYPOINT = 'https://i2open.neoito.com/api';
// export const APP_ENTRYPOINT = 'http://localhost:9000/api';
export const CLIENT_APP_URL = 'https://i2open-client.neoito.com/siginInAs';
